@if (enabled) {
  <button
    type="button"
    class="transparent-btn"
    (click)="cancelContractModal.openModal()"
    ngbTooltip="Annuler le contrat"
    i18n-ngbTooltip
  >
    <app-trash-2-icon height="16px" width="16px" color="var(--error-600)" />
  </button>

  <app-action-modal
    #cancelContractModal
    [disabled]="submitted"
    [showHeader]="true"
    headerIconState="error"
    size="md"
    (submitted)="cancelContract()"
  >
    <app-trash-icon
      height="16px"
      width="16px"
      color="var(--error-600)"
      headerIcon
    />
    <ng-container mainTitle i18n
      >Êtes-vous certain de vouloir annuler le contrat&nbsp;?</ng-container
    >
    <ng-container submitButtonLabel i18n>Confirmer</ng-container>
  </app-action-modal>
}
